import { Button, LinearProgress, Typography } from '@material-ui/core';
import yellow from '@material-ui/core/colors/yellow';
import Warning from '@material-ui/icons/Warning';
import { Voyager } from 'graphql-voyager';
import React, { PureComponent } from 'react';

class SchemaTab extends PureComponent {
    render() {
        return (
            <div className="schema-tab">
                {this.props.environment.response && (
                    <Voyager
                        workerURI={process.env.PUBLIC_URL + '/voyager.worker.js'}
                        introspection={this.props.environment.response}
                        displayOptions={{
                            skipRelay: true
                        }} />
                )}
                {!this.props.environment.response && this.props.fetchingSchema && (
                    <div className="overlay">
                        <div style={{ display: 'flex', flexFlow: 'column nowrap'}}>
                            <Typography color="textSecondary" variant="body1" gutterBottom>Fetching schema</Typography>
                            <LinearProgress variant="query" color="primary" />
                        </div>
                    </div>
                )}
                {!this.props.environment.response && this.props.errorFetchingSchema && (
                    <div className="overlay">
                        <div style={{ margin: '8px 0', display: 'flex', flexFlow: 'row nowrap', alignItems: 'center' }}>
                            <Warning style={{ color: yellow.A100 }} />
                            <Typography variant="subheading" style={{ margin: '0 8px', color: yellow.A100 }}>Failed to fetch schema</Typography>
                        </div>
                        <Button variant="raised" color="primary" onClick={this.props.onRefetchSchema}>RETRY</Button>
                    </div>
                )}
            </div>
        );
    }
}

export default SchemaTab;



// WEBPACK FOOTER //
// ./src/components/SchemaTab.js